import { Injectable } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { MatPaginatorIntl } from '@angular/material/paginator';
import { TranslocoService } from '@ngneat/transloco';
import { TranslateService } from 'app/core/transloco/translate.service';

@Injectable({ providedIn: 'root' })
export class CustomPaginatorService extends MatPaginatorIntl {
    _translocoContent: any;

    constructor(private translate: TranslocoService) {
        super();
        this._translocoContent = toSignal(translate.selectTranslation());

        this.translate.langChanges$.subscribe(() => {
            this.itemsPerPageLabel = this._translocoContent()['grid.paginator'];
        });
    }
}
